import { LINE_HEIGHT_ATTRIBUTE as e, LINE_HEIGHT_TYPES as t } from "./constants.mjs";
import { useLineHeightExtensionToolbar as n } from "./use-line-height-extension-toolbar.mjs";
import { Extension as r } from "@tiptap/core";
import { AllSelection as i, TextSelection as a } from "@tiptap/pm/state";
//#region src/extensions/line-height-extension/index.ts
function o(t, n, r) {
	let i = t.doc.nodeAt(n);
	if (!i) return t;
	let a = {
		...i.attrs,
		[e]: r
	};
	return t.setNodeMarkup(n, i.type, a, i.marks);
}
function s(e, n) {
	let { doc: r, selection: s } = e;
	if (!r || !s || !(s instanceof a || s instanceof i)) return e;
	let { from: c, to: l } = s;
	return r.nodesBetween(c, l, (r, i) => !t.includes(r.type.name) || (e = o(e, i, n), !1)), e;
}
var c = (e) => {
	let t = e.style.lineHeight;
	if (!t || t === "normal") return null;
	let n = t.replace(/['"]+/g, ""), r = parseFloat(n);
	return Number.isNaN(r) ? null : /[a-z%]/i.test(n) ? n : r;
}, l = r.create({
	name: "lineHeight",
	addOptions() {
		return { types: t };
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { [e]: {
				default: null,
				parseHTML: (e) => c(e),
				renderHTML: (t) => t.lineHeight ? { style: `line-height: ${t[e]}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setLineHeight: (e) => ({ tr: t, state: n, dispatch: r }) => {
				let { selection: i } = n;
				return t = t.setSelection(i), t = s(t, e), t.docChanged ? (r && r(t), !0) : !1;
			},
			unsetLineHeight: () => ({ tr: e, state: t, dispatch: n }) => {
				let { selection: r } = t;
				return e = e.setSelection(r), e = s(e, null), e.docChanged ? (n && n(e), !0) : !1;
			}
		};
	}
});
//#endregion
export { l as LineHeightExtension, n as useLineHeightExtensionToolbar };
